<template>
  <main onclick class="page-content">
    <div class="card" v-bind:style="bgStyle"> 
      <div class="content">
        <h2 class="title">{{ restaurantName.replace("AS", "") }}</h2>
        <div class="copy">
          <p>
            {{ address }}
          </p>
          <p>{{ postNumber }}, {{ city }}</p>
          <p>Tlf: {{ phoneNumber.toString().replace(/\d{2}(?=.)/g, "$& ") }}</p>
          <p v-show="!isClosed">
            Åpningstider: <br />
            {{ fromTime }} - {{ toTime }}
          </p>
          <p v-show="isClosed">
            STENGT<br />
          </p>
        </div>

        <div class="buttons">
          <a href="#"><button class="btn" @click="handleBtnVelg">Velg</button></a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "RestaurantCard",
  components: {},
  props: {
    restaurantId: { type: Number },
    restaurantName: { type: String },
    address: { type: String },
    city: { type: String },
    postNumber: { type: Number },
    imageUrl: { type: String },
    fromTime: { type: String },
    toTime: { type: String },
    isClosed: { type: Boolean },
    phoneNumber: { type: String },
    inActive: { type: Boolean },
    isClosed : {type: Boolean }
  },
  data() {
    return {
      cardImage: {
        bgImage: "url(" + this.imageUrl + ")"
      }
    };
  },
  computed: {
    getAddress() {
      return this.address + ", " + this.postNumber + " " + this.city;
    },
    bgStyle() {
      return {
        "--bgImage-before": this.cardImage.bgImage
      };
    }
  },
  methods: {
    handleBtnVelg() {
      let id = this.restaurantId;
      let name = this.restaurantName;

      this.$emit("buttonPressed", { restaurantId: id, restaurantName: name });
    },
    handleBtnInfo(){
      this.$modal.show("moreInfo");
    }
  },
  created() {
    this.url = this.imageUrl;
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Cardo:400i|Rubik:400,700&display=swap");

$bp-md: 600px;
$bp-lg: 800px;

:root {
  --d: 700ms;
  --e: cubic-bezier(0.19, 1, 0.22, 1);
  --font-sans: "Bebas", sans-serif;
  --font-serif: "Cardo", sans-serif;
}

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  place-items: center;
}

.page-content {
  max-width: 1024px;
  margin: 0 auto;
  font-family: var(--font-sans);
}

.card {
  position: relative;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  padding: 1rem;
  width: 100%;
  text-align: center;
  color: whitesmoke;
  background-color: whitesmoke;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.1),
    0 4px 4px rgba(0, 0, 0, 0.1), 0 8px 8px rgba(0, 0, 0, 0.1),
    0 16px 16px rgba(0, 0, 0, 0.1);

  @media (min-width: $bp-md) {
    height: 350px;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
    background-size: cover;
    background-position: 0 0;
    transition: transform calc(var(--d) * 1.5) var(--e);
    background-image: var(--bgImage-before);
    pointer-events: none;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      hsla(0, 0%, 0%, 0) 0%,
      hsla(0, 0%, 0%, 0.009) 11.7%,
      hsla(0, 0%, 0%, 0.034) 22.1%,
      hsla(0, 0%, 0%, 0.072) 31.2%,
      hsla(0, 0%, 0%, 0.123) 39.4%,
      hsla(0, 0%, 0%, 0.182) 46.6%,
      hsla(0, 0%, 0%, 0.249) 53.1%,
      hsla(0, 0%, 0%, 0.32) 58.9%,
      hsla(0, 0%, 0%, 0.394) 64.3%,
      hsla(0, 0%, 0%, 0.468) 69.3%,
      hsla(0, 0%, 0%, 0.54) 74.1%,
      hsla(0, 0%, 0%, 0.607) 78.8%,
      hsla(0, 0%, 0%, 0.668) 83.6%,
      hsla(0, 0%, 0%, 0.721) 88.7%,
      hsla(0, 0%, 0%, 0.762) 94.1%,
      hsla(0, 0%, 0%, 0.79) 100%
    );
    transform: translateY(-50%);
    transition: transform calc(var(--d) * 2) var(--e);
  }
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 1rem;
  transition: transform var(--d) var(--e);
  z-index: 1;
}

.title {
  font-size: 1.9rem;
  font-weight: bold;
  line-height: 1.2;
  text-transform: capitalize;
  color: white;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.copy {
  font-family: var(--font-serif);
  font-size: 1.5rem;

  line-height: 1.35;
}

.btn {
  cursor: pointer;
  margin: 5px;
  width: 115px;
  transition: all 0.5s ease !important;
  color: #fff;
  border: 1px solid white;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  font-size: 20px;
  background-color: transparent;
  padding: 10px;
  outline: none;
  border-radius: 8px;

  &:hover {
    color: #001f3f;
    background-color: #fff;
  }

  &:focus {
    outline-offset: 3px;
  }
}

.card:after {
  transform: translateY(0);
}

.content {
  transform: translateY(calc(100% - 4.5rem));

  > *:not(.title) {
    opacity: 0;
    transform: translateY(1rem);
    transition: transform var(--d) var(--e), opacity var(--d) var(--e);
  }
}

.card:hover,
.card:focus-within {
  align-items: center;

  &:before {
    transform: translateY(-4%);
  }
  &:after {
    transform: translateY(-50%);
  }

  .content {
    transform: translateY(0);

    > *:not(.title) {
      opacity: 1;
      transform: translateY(0);
      transition-delay: calc(var(--d) / 8);
    }
  }
}

.card:focus-within {
  &:before,
  &:after,
  .content,
  .content > *:not(.title) {
    transition-duration: 0s;
  }
}
</style>
